import BaseStore from '@/store/base-store'

const options = {}
export default new BaseStore('branches', options)



// WEBPACK FOOTER //
// ./src/store/modules/branches.store.js